import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import { watchThrottled } from '@vueuse/core';
import Fuse from 'fuse.js';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useSearchFacets } from '@/composables/_next/useSearchFacets';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzSearchFilterTag',
  props: {
    facetId: null,
    placeholder: null,
    options: null,
    callout: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useSearchFacets = useSearchFacets(),
      addSearchFacet = _useSearchFacets.addSearchFacet,
      facets = _useSearchFacets.facets,
      removeSearchFacet = _useSearchFacets.removeSearchFacet;
    var focused = ref(false);
    var query = ref('');
    var results = ref([]);
    var hasResults = computed(function () {
      return results.value.length > 0;
    });
    var choices = computed(function () {
      return props.options;
    });
    var fuse = computed(function () {
      return new Fuse(choices.value, {
        keys: ['0'],
        includeScore: true,
        distance: 100,
        threshold: 0.5
      });
    });
    var showDropdown = computed(function () {
      return focused.value && query.value.length >= 3;
    });
    var selectedTags = computed(function () {
      var _facets$value;
      return (_facets$value = facets.value) === null || _facets$value === void 0 ? void 0 : _facets$value[props.facetId];
    });
    watchThrottled(query, function () {
      if (query.value.length >= 3) {
        results.value = fuse.value.search(query.value).map(function (result) {
          return result.item;
        });
      } else {
        results.value = [];
      }
    }, {
      throttle: 500
    });
    function onBlur() {
      // focused.value = false;
    }
    function onFocus() {
      focused.value = true;
    }
    function clearQuery() {
      query.value = '';
    }
    function onResultClick(_x) {
      return _onResultClick.apply(this, arguments);
    }
    function _onResultClick() {
      _onResultClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(option) {
        var _selectedTags$value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!((_selectedTags$value = selectedTags.value) !== null && _selectedTags$value !== void 0 && _selectedTags$value.includes(option))) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return addSearchFacet(props.facetId, option);
            case 4:
              clearQuery();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onResultClick.apply(this, arguments);
    }
    function onRemoveTag(_x2) {
      return _onRemoveTag.apply(this, arguments);
    }
    function _onRemoveTag() {
      _onRemoveTag = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(option) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return removeSearchFacet(props.facetId, option);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _onRemoveTag.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      addSearchFacet: addSearchFacet,
      facets: facets,
      removeSearchFacet: removeSearchFacet,
      focused: focused,
      query: query,
      results: results,
      hasResults: hasResults,
      choices: choices,
      fuse: fuse,
      showDropdown: showDropdown,
      selectedTags: selectedTags,
      onBlur: onBlur,
      onFocus: onFocus,
      clearQuery: clearQuery,
      onResultClick: onResultClick,
      onRemoveTag: onRemoveTag,
      AzInput: AzInput,
      AzIcon: AzIcon
    };
  }
});